import { jsx, jsxs } from "react/jsx-runtime";
import { memo, forwardRef } from "react";
import { IconBase } from "src/components/ui/IconBase";
export default memo(forwardRef(function IconSvgSwitch({
  className,
  "data-test-id": dataTest = "IconSwitch",
  ...props
}, ref) {
  return /* @__PURE__ */ jsx(IconBase, { ...props, "data-test-id": dataTest, className, innerRef: ref, children: /* @__PURE__ */ jsxs("svg", { viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx("g", { clipPath: "url(#clip0_3018_11800)", children: /* @__PURE__ */ jsx("path", { d: "M11.2 8.03337L14.5 11.3334L11.2 14.6334L10.2573 13.6907L11.948 11.9994L3.16667 12V10.6667H11.948L10.2573 8.97603L11.2 8.03337ZM5.8 1.3667L6.74267 2.30937L5.052 4.00003H13.8333V5.33337H5.052L6.74267 7.02403L5.8 7.9667L2.5 4.6667L5.8 1.3667Z", fill: "#6E7076" }) }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_3018_11800", children: /* @__PURE__ */ jsx("rect", { width: 16, height: 16, fill: "white", transform: "translate(0.5)" }) }) })
  ] }) });
}));
